import React, { useState } from "react";
import "./Navbar.css"; // Import CSS file for styling
import { Link, useLocation, useNavigate} from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars,faArrowLeft,faVideo,faQuestionCircle,faStar,faWallet, faUser, faClockRotateLeft, faLongArrowAltLeft} from '@fortawesome/free-solid-svg-icons';
import IconWithRoundedBorder from "../components/borderCir/BoderCir";
import NavImage from "./NavImage";
import LanguageSwitcher from "./LanguageSwitcher";
import { useT } from "../i18n";
export default function Navbar() {
  const { Info } = useSelector((state) => state.users);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useT();


  const handleBackClick = () => {
      navigate(-1); // Go back to the previous page
  };

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };
  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const logoutComp =()=>{
    localStorage.removeItem('user-session');
    localStorage.clear();
    window.location.href='/login';
  }

  const isHome = location.pathname === '/home' || location.pathname === '/';

  // const handlePageClick = (event) => {
  //   if (!event.target.classList.contains("missed")) {
  //    setIsMenuOpen(false);
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("click", handlePageClick);
  //   return () => {
  //     document.removeEventListener("click", handlePageClick);
  //   };
  // }, []);


  
  return (
    // <nav className="navbar">
    //   <div className="navbar-container">
    //     {/* Logo */}
    //     <Link to="/" className="navbar-logo">
    //       {APP_NAME}
    //     </Link>

    //     {/* Desktop Links */}
    //     <ul className={`nav-links ${isMenuOpen ? "active" : ""}`}>
    //       <li><Link to="/">Home</Link></li>
    //       {(Info?.status=='1')?<><li><Link to="/profile">My Profile</Link></li>
    //       <li><Link to="/my-bid">My Bid</Link></li>
    //       <li><Link to="/account-statement">Account Statement</Link></li>
    //       <li><Link to="/game-rates">Game Rates</Link></li>
    //       <li><Link to="/how-to-play">How to Play</Link></li>
    //       <li><Link to="/privacy-policy">Privacy Policy</Link></li></>:<></>}
    //       <li><Link to="/logout" onClick={logoutComp}>Logout</Link></li>
    //     </ul>

    //     {/* Toggle Button for Mobile */}
    //     <button className="menu-toggle missed"  onClick={toggleMenu}>
    //       <span className="bar missed"></span>
    //       <span className="bar missed"></span>
    //       <span className="bar missed"></span>
    //     </button>
    //   </div>
    // </nav>

    <div id="app__" style={{position:'fixed',width:'100%',zIndex:'9900'}}>
      {/* Header */}
      <header className="header app-header">
        {isHome
          ? <button onClick={toggleSidebar} className="hdr-icon-btn" aria-label={t('Open menu')}><FontAwesomeIcon icon={faBars} /></button>
          : <button onClick={handleBackClick} className="hdr-icon-btn" aria-label={t('Go back')}><FontAwesomeIcon icon={faArrowLeft} /></button>}
        <Link to="/" className="hdr-logo"><NavImage/></Link>

        {Info?.status==='1'&&<div className="hdr-right">
          <div className="hdr-balance">
            <strong>{Info?.wallet}</strong>
            <span>{t('Wallet')}</span>
          </div>
          <Link to="/wallet_histroy" className="hdr-circle" aria-label={t('Wallet')}><FontAwesomeIcon icon={faWallet} /></Link>
          <Link to="/profile" className="hdr-circle" aria-label={t('Profile')}><FontAwesomeIcon icon={faUser} /></Link>
        </div>}
      </header>

      {/* Overlay: dims the page while the sidebar is open; tap to close */}
      <div className={`sidebar-overlay ${isSidebarOpen ? "open" : ""}`} onClick={closeSidebar} aria-hidden="true" />

      {/* Sidebar */}
      <aside className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <div className="sidebar-profile">
          <div className="sidebar-avatar" aria-hidden="true">
            <FontAwesomeIcon icon={faUser} />
          </div>
          <div className="sidebar-user-details">
            <span className="sidebar-user-name">{Info?.name || t('My Profile')}</span>
            <span className="sidebar-user-phone">{Info?.phone_number ? `+91 ${Info.phone_number}` : ''}</span>
            <span className="sidebar-user-since">{Info?.created_at ? t('Since {date}',{date:Info.created_at}) : ''}</span>
          </div>
          <button onClick={closeSidebar} className="close-button sidebar-close" aria-label={t('Close menu')}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <ul className="menu_left sidebar-menu">
        {Info?.status==='1'&&<><li ><Link to="/account-statement" onClick={closeSidebar}><IconWithRoundedBorder paddingBox={'10px'} outerColor={'#007bff'} innerColor={'#007bff'}  FonCompo={<FontAwesomeIcon icon={faClockRotateLeft} size='1x' color="white" cursor='pointer'/>}/> &nbsp;{t('Account Statement')}</Link></li>
        <li><Link to="/game-rates" onClick={closeSidebar}><IconWithRoundedBorder paddingBox={'10px'} outerColor={'#007bff'} innerColor={'#007bff'}  FonCompo={<FontAwesomeIcon icon={faStar} size='1x' color="white" cursor='pointer'/>}/>&nbsp;{t('Game Rates')}</Link></li>
        <li><Link to="/privacy-policy" onClick={closeSidebar}><IconWithRoundedBorder paddingBox={'10px'} outerColor={'#007bff'} innerColor={'#007bff'}  FonCompo={<FontAwesomeIcon icon={faQuestionCircle} size='1x' color="white" cursor='pointer'/>}/>&nbsp;{t('Terms & Conditions')}</Link></li>
        <li><Link to="/how-to-play" onClick={closeSidebar}><IconWithRoundedBorder  paddingBox={'10px'} outerColor={'#007bff'} innerColor={'#007bff'}  FonCompo={<FontAwesomeIcon icon={faVideo} size='1x' color="white" cursor='pointer'/>}/> &nbsp;{t('Video')}</Link></li></>}
        <li><Link to="/logout" onClick={logoutComp}><IconWithRoundedBorder paddingBox={'10px'} outerColor={'#007bff'} innerColor={'#007bff'}  FonCompo={<FontAwesomeIcon icon={faLongArrowAltLeft} size='1x' color="white" cursor='pointer'/>}/>&nbsp;{t('Logout')}</Link></li>
        </ul>
        <div className="sidebar-lang">
          <span>{t("Language")}</span>
          <LanguageSwitcher />
        </div>
        <p className="brand-tagline sidebar-tagline">{t("Every Win, Securely Paid.")}</p>
      </aside>
      </div>
  );
}
